import { isClerkAuthEnabled } from '@/utils/auth/authMode';

import ClerkSignUpPage from './ClerkSignUpPage';
import PaddleSignUpPage from './PaddleSignUpPage';

/** Clerk account sign-up at `/sign-up`, or legacy Paddle wizard when Clerk is not configured. */
const SignUpPage = () => {
  if (isClerkAuthEnabled()) {
    return <ClerkSignUpPage />;
  }
  return <PaddleSignUpPage />;
};

export default SignUpPage;
